import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";

import Image from "next/image";
import ChipBlog from "./chipBlog";
import Link from "next/link";

const BlogList = ({ item, isSpacing }) => {
    return (
        <div className={isSpacing ? "mx-2.5 py-3" : ""}>
            <div className="group relative h-full">
                <div className="bg-white h-full text-black shadow-md rounded-xl overflow-hidden">
                    <div className="relative md:h-56 h-44">
                        <Link
                            href={`/${item?.urlSlug}`}
                            title={item?.pageName}
                            passHref
                        >
                            <Image
                                src={`${NEXT_IMAGE_CDN}/${item.cardImage}`}
                                alt={item.urlSlug}
                                width={0}
                                height={0}
                                sizes="(max-width: 768px) 100vw"
                                loading="lazy"
                                className="w-full h-full object-cover rounded-tl-xl rounded-tr-xl group-hover:scale-105 transition-transform duration-300 ease-in-out"
                            />
                        </Link>
                    </div>

                    <div className="md:p-4 p-3">
                        <p className="md:text-sm text-xs font-light text-gray-800">
                            {item.publishedOn}
                        </p>
                        <p
                            variant="h3"
                            className="md:text-base text-sm font-semibold"
                        >
                            <Link
                                href={`/${item?.urlSlug}`}
                                title={item?.pageName}
                            >
                                {item.pageName}
                            </Link>
                        </p>
                        <div className="">
                            {item?.taggedSpecializations?.map((tag, index) => (
                                <ChipBlog key={index} tag={tag} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogList;
